import React, { Component } from 'react'
import { Table, Tag, message, Popconfirm, Checkbox, Button, Input, Modal, Form, Upload, Select, InputNumber } from 'antd';
import { FirebaseRef } from '../../lib/firebase'
import { uploadMutipleFile } from '../../actions/app'
import { PlusOutlined, LoadingOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { connect } from "react-redux"
import moment from "moment"
const { TextArea } = Input;

const DEFAULT = {
  description: '',
  index: '',
  isShow: false,
  question: "",
  relatedQuestion: [],
  answers: []
}
class Questions extends Component {
  constructor(props) {
    super(props)
    this.formRef = React.createRef();
    this.timeOut = null
    this.state = {
      data: [],
      loading: false,
      visibleModal: false,
      action: false,
      status: 'pending',
      item: DEFAULT,
      loadingImage: false,
      imgUrl: "",
      loadingImageAuthor: false,
      imgUrlAuthor: "",
      topicData: []
    }
  }

  componentDidMount() {
    // const { role, uid } = this.props.member;
    this.setState({
      loading: true
    })
    let ref = FirebaseRef.child(`/questions`)

    // if (role !== "admin") {
    //   ref = FirebaseRef.child(`/questions`).orderByChild("authorId").equalTo(uid)
    // }
    ref.on('value', snapshot => {
      const data = snapshot.val()
      let newData = []
      if (data && typeof (data) === 'object') {

        Object.keys(data).forEach(key => {
          if (data[key]) {
            newData.push({
              ...data[key],
              id: key,
            })
          }
        })

        const newArray = newData.reverse()

        this.setState({
          data: newArray,
          loading: false,
        })
      } else {
        this.setState({
          loading: false,
          data: []
        })
      }
    })

    this.handleFetchTopicData()
  }

  handleFetchTopicData() {
    let ref = FirebaseRef.child(`/Topic`)
    ref.on('value', snapshot => {
      const data = snapshot.val()
      let newData = []
      if (data && typeof (data) === 'object') {

        Object.keys(data).forEach(key => {
          if (data[key]) {
            newData.push({
              ...data[key],
              id: key,
            })
          }
        })
        const newArray = newData.reverse()
        this.setState({
          topicData: newArray,
        })
      }
    })
  }



  confirm(id) {
    const ref = FirebaseRef.child(`/questions/${id}`)

    ref.remove().then(() => {
      message.success("Questions was removed!")

    }).catch(err => {
      message.error(err)
    })
  }

  handleShowModal() {
    this.setState({
      visibleModal: true
    })
  }

  handleCloseModal() {
    this.setState({
      visibleModal: false,
      item: DEFAULT,
      imgUrl: ''
    })
  }

  beforeUpload(file) {

    const isLt4M = file.size / 1024 / 1024 < 4
    if (!isLt4M) {
      message.error('Image must smaller than 4MB!')
    }
    return isLt4M
  }

  handleUploadImage(file) {
    uploadMutipleFile(file, `${file.uid}/app/img`).then(result => {
      const { url, isSuccess } = result

      if (isSuccess) {
        this.setState({
          imgUrl: url
        })
      }
    })
  }

  handleChangeImage = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loadingImage: true })
      return
    }
    if (info.file.status === 'done' || info.file.status === 'error') {
      // Get this url from response in real world.
      this.handleUploadImage(info.file.originFileObj)
      this.getBase64(info.file.originFileObj, _ => this.setState({
        loadingImage: false,
      }
      ))
    }
  };

  handleChangeImageAuthor = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loadingImageAuthor: true })
      return
    }
    if (info.file.status === 'done' || info.file.status === 'error') {
      // Get this url from response in real world.
      this.handleUploadImageAuthor(info.file.originFileObj)
      this.getBase64(info.file.originFileObj, _ => this.setState({
        loadingImageAuthor: false,
      }
      ))
    }
  };

  handleUploadImageAuthor(file) {
    uploadMutipleFile(file, `${file.uid}/app/imgAuthor`).then(result => {
      const { url, isSuccess } = result

      if (isSuccess) {
        this.setState({
          imgUrlAuthor: url
        })
      }
    })
  }

  getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  onFinish(values) {
    const { member } = this.props
    const { imgUrlAuthor } = this.state
    const newMember = {
      displayName: values.authorName || '',
      email: member.email || '',
      imgUrl: imgUrlAuthor || member.imgUrl,
      nickname: values.authorName || member.nickname,
      phone: member.phone || '',
      job: member.job || '',
    }

    const { imgUrl, item } = this.state
    values.imgUrl = imgUrl || ""
    values.imgUrlAuthor = imgUrlAuthor || ""
    values.updated = moment().format('ll');
    const that = this
    values.member = newMember
    if (!values.authorName) {
      values.authorName = member.nickname || ''
    }

    values.authorId = member.uid
    Object.keys(values).forEach(key => {
      if (!values[key]) {
        values[key] = ''
      }
    })
    if (item.id) {

      FirebaseRef.child(`/questions/${item.id}`).set({ ...item, ...values }).then(() => {
        message.success("Questions have been aldready updated!")
        that.handleCloseModal()
      })
    } else {
      const Ref = FirebaseRef.push()
      const key = Ref.getKey()
      values.adjustData = []
      values.authorId = member.uid
      FirebaseRef.child(`/questions/${key}`).set({ ...values }).then(() => {
        message.success("Questions have been aldready created!")
        that.handleCloseModal()
      })
    }
  }

  render() {

    const columns = [
      {
        title: 'Image',
        dataIndex: 'imgUrl',
        key: 'imgUrl',
        render: (text, record) => <>
          <img alt="img" style={{ width: 'auto', height: 'auto', maxWidth: "100px", maxHeight: "100px" }} src={record.imgUrl ? record.imgUrl : `/assets/img/no_Image.png`} />
        </>,
      },
      {
        title: 'Question',
        dataIndex: 'question',
        key: 'question',
        render: text => <>
          {text}
        </>,
      },

      {

        title: 'Description',
        dataIndex: 'description',
        key: 'description',

      },
      {
        title: 'Answers',
        dataIndex: 'answers',
        key: 'answers',
        render: text => {

          return (
            <>
              {Array.isArray(text) ? (
                <>
                  {text.map((el, index) => <div>
                    {el.answer || ''}
                    {index !== text.length - 1 ? (<hr />) : ""}

                  </div>)}
                </>
              ) : <>{text}</>}
            </>
          )
        },
      },
      {
        title: 'Should show',
        dataIndex: 'isShow',
        key: 'isShow',
        render: (_, record) => <>
          <Checkbox checked={record.isShow} />
        </>,
      },
      {
        title: 'Index',
        dataIndex: 'index',
        key: 'index',

        render: text => <>
          {text}
        </>,
      },
      {
        title: 'Emoji data',
        dataIndex: 'adjustData',
        key: 'adjustData',
        render: (text, record) => {
          const newData = {}
          if (record.adjustData) {
            record.adjustData.forEach(item => {
              if (newData[item.nickname]) {
                newData[item.nickname].push(item.key)
              } else {
                newData[item.nickname] = [item.key]
              }
            })
          }
          return (
            <>
              {newData ? (
                <div>
                  {Object.keys(newData).map((index) => (
                    <div key={index}>
                      <div style={{ fontWeight: 'bold' }}>{index}</div>
                      {newData[index] && newData[index].map(item => (
                        <div> {item}</div>
                      ))}
                    </div>
                  ))}
                </div>
              ) : ""}
            </>
          )
        },
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          <span style={{ display: "flex", }}>
            <Popconfirm placement="top" title={"Are you sure you will delete this questions?"} onConfirm={() => { this.confirm(record.id) }} okText="Yes" cancelText="No">
              <Tag color={"red"} key={"delete"}>
                Delete
                </Tag>
            </Popconfirm>
            <Tag onClick={() => {
              record.index = record.index || 0
              this.setState({
                item: record,
                imgUrl: record.imgUrl,
                imgUrlAuthor: record.imgUrlAuthor,
                visibleModal: true
              })
            }} color={"blue"} key={"edit"}>
              Edit
             </Tag>
          </span >
        ),
      },
    ];
    const { data, loading, visibleModal, item, loadingImage, imgUrl, topicData } = this.state
    const { role, uid } = this.props.member
    const uploadButton = (
      <div>
        {
          loadingImage ? (<LoadingOutlined></LoadingOutlined>) : (<PlusOutlined></PlusOutlined>)
        }

        <div className="ant-upload-text">Drop an image here, or select a file.</div>
      </div>
    )


    // const uploadButtonAuthor = (
    //   <div>
    //     {
    //       loadingImageAuthor ? (<LoadingOutlined></LoadingOutlined>) : (<PlusOutlined></PlusOutlined>)
    //     }

    //     <div className="ant-upload-text">Drop an image here, or select a file.</div>
    //   </div>
    // )
    console.log(23131, 213123, uid)
    return (
      <div >
        <div style={{ textAlign: "right", width: "100%", marginBottom: "15px" }}>
          <Button onClick={() => { this.handleShowModal() }} type="primary" >
            Add Question
        </Button>
        </div>
        <Table loading={loading} columns={columns} dataSource={data} />
        {visibleModal ? (
          <Modal
            title={`${item.id ? "Edit" : "Add"} Question`}
            visible={visibleModal}
            size="large"
            footer={
              []
            }
            onCancel={() => {
              this.handleCloseModal()
            }}
          >

            <Form ref={this.formRef} onFinish={(values) => { this.onFinish(values) }} className="Custorm" layout={"vertical"} initialValues={item}>
              <Form.Item
                label="Question"
                name="question"
                rules={[{ required: true, message: 'Please input your Question!' }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Image"

              >
                <Upload
                  name="imgUrl"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  beforeUpload={(file) => { this.beforeUpload(file) }}
                  onChange={(info) => { this.handleChangeImage(info) }}
                >
                  {imgUrl ? <img src={imgUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                </Upload>
              </Form.Item>
              <Form.Item
                label="Description"
                name="description"
              >
                <TextArea rows={4} />
              </Form.Item>
              <Form.Item
                label="Should show"
                name="isShow"
                valuePropName="checked"
              >
                {/* disabled={role !== "admin"} */}
                <Checkbox ></Checkbox>
              </Form.Item>
              {role === "admin" ? (
                <Form.Item
                  label="Index"
                  name="index"
                >
                  <InputNumber min={0} max={100} style={{ width: "100%" }} />
                </Form.Item>
              ) : null}

              <Form.Item
                label="Related Question"
                name="relatedQuestion"
              >
                <Select
                  mode="multiple"
                  style={{ width: '100%' }}
                  placeholder="select related question"
                >
                  {data.map(item => (
                    <Select.Option key={item.id} value={item.question}>
                      {item.question}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Topic"
                name="topic"
              >
                <Select
                  style={{ width: '100%' }}
                  placeholder="select topic"
                >
                  {topicData.map(item => (
                    <Select.Option key={item.id} value={item.Topic}>
                      {item.Topic}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.List
                name="answers"
              >
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field, index) => (
                      <Form.Item

                        label={index === 0 ? 'Answers' : ''}
                        required={false}
                        key={field.key}
                      >
                        <Form.Item
                          {...field}
                          name={[field.name, 'parentId']}
                          fieldKey={[field.fieldKey, 'parentId']}
                          style={{ display: 'none' }}
                          initialValue={uid}
                        >
                          <Input style={{ width: '100%' }} />
                        </Form.Item>
                        <div style={{ position: 'relative' }}>
                          <Form.Item
                            {...field}
                            name={[field.name, 'answer']}
                            fieldKey={[field.fieldKey, 'answer']}
                          >
                            <TextArea onChange={() => {
                              if (this.timeOut) {
                                clearTimeout(this.timeOut)
                              }
                              const that = this
                              this.timeOut = setTimeout(() => {
                                const answers = that.formRef.current.getFieldValue('answers')
                                answers[index].parentId = uid
                                that.formRef.current.setFieldsValue({
                                  answers,
                                });
                              }, 500)

                            }} rows={4} style={{ width: '100%' }} />
                          </Form.Item>

                          {fields.length > 1 ? (
                            <MinusCircleOutlined
                              style={{ position: 'absolute', right: 5, top: 5 }}
                              className="dynamic-delete-button"
                              onClick={() => remove(field.name)}
                            />
                          ) : null}
                        </div>
                      </Form.Item>

                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        style={{ width: '60%' }}
                        icon={<PlusOutlined />}
                      >
                        Add answers
                      </Button>

                    </Form.Item>
                  </>
                )}
              </Form.List>
              {/* <Form.Item
                label="Author name"
                name="authorName"
              >
                <Input defaultValue="" />
              </Form.Item>
              <Form.Item
                label="Image"

              >
                <Upload
                  name="imgUrlAuthor"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  beforeUpload={(file) => { this.beforeUpload(file) }}
                  onChange={(info) => { this.handleChangeImageAuthor(info) }}
                >
                  {imgUrlAuthor ? <img src={imgUrlAuthor} alt="avatar" style={{ width: '100%' }} /> : uploadButtonAuthor}
                </Upload>
              </Form.Item> */}
              <Form.Item style={{ textAlign: 'right', marginTop: '10px' }}>
                <Button type="primary" htmlType="submit">
                  {item.id ? "Edit" : "Add"}
                </Button>
              </Form.Item>

            </Form>
          </Modal>
        ) : null}
      </div >
    )
  }

}

const mapStateToProps = state => ({
  member: state.member || {},
});



export default connect(mapStateToProps, null)(Questions)
